module.exports = require("@opentelemetry/api");